import debounce from 'lodash/debounce';
import { useListInstitutionMutation } from '../../../../../../api/useListInstitutionsMutation';

export const useInstitutionList = () => {
  const queryMutation = useListInstitutionMutation();

  const loadInstitutions = debounce((term, callback) => {
    queryMutation.mutateAsync(term).then(opt => {
      const sortedInstitutions = opt.Data.sort((a, b) => {
        const x = a.Term.toLowerCase();
        const y = b.Term.toLowerCase();
        // eslint-disable-next-line
        return x < y ? -1 : x > y ? 1 : 0;
      });

      const filterByQuery = sortedInstitutions.filter(
        ({ Term }) => Term.toLowerCase().indexOf(term.toLowerCase()) === 0,
      );

      const limitedAmountOfInstitutions = filterByQuery.slice(0, 50).map(institution => ({
        label: institution.Term,
        value: institution.Value,
      }));

      callback(limitedAmountOfInstitutions);
    });
  }, 300);

  return {
    ...queryMutation,
    loadInstitutions,
  };
};
